<template>
    <div>
        <slot name="title">
            <h5 class="grey-color mt-3 mb-1 main_text font-weight-bold">Разногласия по контракту</h5>
        </slot>
        <div class="table-responsive">
            <table class="table b-table">
                <fragment v-for="(disagreement, index) in disagreements" :key="index">
                    <tr>
                        <th style="width: 1px;" class="py-1">№</th>
                        <th class="text-nowrap py-1">Протокол разногласий (поставщик)</th>
                        <th class="py-1">Комментарий поставщика</th>
                        <th style="width: 100px;" class="py-1">Направлен</th>
                        <th style="width: 50px;" class="py-1">Подпись</th>
                    </tr>
                    <tr>
                        <td :rowspan="!disagreement.customer_attachment ? 1 : 3" class="py-1">{{ index + 1 }}</td>
                        <td class="text-nowrap py-1">
                            <a class="atmo-button-link" :href="$getAttachmentDownloadLink(disagreement.supplier_attachment.id)" target="_blank">{{ disagreement.supplier_attachment.name }}</a>
                        </td>
                        <td class="py-1">{{ disagreement.supplier_comment }}</td>
                        <td class="text-nowrap py-1">{{ $formatDateTime(disagreement.created_at) }}</td>
                        <td class="text-center text-nowrap py-1">
                            <action-button-small icon="clipboard-check" title="Информация о подписи" @click="showSign(false, disagreement.supplier_attachment.supplier_signature)" />
                            <action-button-small v-if="disagreement.supplier_attachment.supplier_signature.poa_number && disagreement.supplier_attachment.supplier_signature.poa_check_link" class="ml-1" icon="clipboard-plus" title="Информация о МЧД" variant="warning" @click="showSign(true, disagreement.supplier_attachment.supplier_signature)" />
                            <action-button-small icon="cloud-download" title="Скачать файл подписи" variant="outline" class="ml-1" @click="download(disagreement.supplier_attachment.supplier_signature.md5, false, disagreement.supplier_attachment.name)" />
                        </td>
                    </tr>
                    <template v-if="disagreement.customer_attachment">
                        <tr>
                            <th class="text-nowrap py-1">Ответ на протокол разногласий (заказчик)</th>
                            <th class="py-1">Комментарий заказчика</th>
                            <th class="py-1">Направлен</th>
                            <th class="py-1">Подпись</th>
                        </tr>
                        <tr>
                            <td class="text-nowrap py-1">
                                <a class="atmo-button-link" :href="$getAttachmentDownloadLink(disagreement.customer_attachment.id)" target="_blank">{{ disagreement.customer_attachment.name }}</a>
                            </td>
                            <td class="py-1">{{ disagreement.customer_comment }}</td>
                            <td class="text-nowrap py-1">{{ $formatDateTime(disagreement.updated_at) }}</td>
                            <td class="text-center text-nowrap py-1">
                                <action-button-small icon="clipboard-check" title="Информация о подписи" @click="showSign(true, disagreement.customer_attachment.customer_signature)" />
                                <action-button-small v-if="disagreement.customer_attachment.customer_signature.poa_number && disagreement.customer_attachment.customer_signature.poa_check_link" class="ml-1" icon="clipboard-plus" title="Информация о МЧД" variant="warning" @click="showSign(true, disagreement.customer_attachment.customer_signature)" />
                                <action-button-small icon="cloud-download" title="Скачать файл подписи" variant="outline" class="ml-1" @click="download(disagreement.customer_attachment.customer_signature.md5, true, disagreement.customer_attachment.name)" />
                            </td>
                        </tr>
                    </template>
                </fragment>
            </table>
        </div>
        <show-sign-modal v-if="signData.signature" :signature="signData.signature" :org-is-customer="signData.isCustomer" :show="showSignModal" @close="showSignModal = false" />
    </div>
</template>

<script>
import { encodeBase64, saveAs } from '@progress/kendo-file-saver';

export default {
    name: 'text-row-disagreement-table',
    props: {
        disagreements: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            showSignModal: false,
            signData: {
                signature: null,
                isCustomer: false
            }
        };
    },
    methods: {
        showSign(isCustomer, signature) {
            this.signData.isCustomer = isCustomer;
            this.signData.signature = signature;
            this.showSignModal = true;
        },
        download(signature, isCustomer, fileName) {
            const downloadData = 'data:text/plain;base64,' + encodeBase64(signature);
            const downloadFileName = (isCustomer ? 'customer_' : 'supplier_') + fileName + '.sig';
            saveAs(downloadData, downloadFileName);
        }
    }
};
</script>
